import React, { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./SchDocumentsUIHelpers";

const SchDocumentsUIContext = createContext();

export function useSchDocumentsUIContext() {
  return useContext(SchDocumentsUIContext);
}

export const SchDocumentsUIConsumer = SchDocumentsUIContext.Consumer;

export function SchDocumentsUIProvider({ schDocumentsUIEvents, children }) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const [ids, setIds] = useState([]);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const value = {
    queryParams,
    setQueryParamsBase,
    ids,
    setIds,
    setQueryParams,
    newSchDocumentButtonClick: schDocumentsUIEvents.newSchDocumentButtonClick,
    openEditSchDocumentPage: schDocumentsUIEvents.openEditSchDocumentPage,
    openDeleteSchDocumentDialog: schDocumentsUIEvents.openDeleteSchDocumentDialog,
    openDeleteSchDocumentsDialog: schDocumentsUIEvents.openDeleteSchDocumentsDialog,
    openFetchSchDocumentsDialog: schDocumentsUIEvents.openFetchSchDocumentsDialog,
  };

  return (
    <SchDocumentsUIContext.Provider value={value}>
      {children}
    </SchDocumentsUIContext.Provider>
  );
}
